import axios from "axios";
import { useMemo, useState } from "react";

const getDailyNFTSellers = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/marketOverview/dailynewsellers"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useNFTSellers() {
    const [api, setAPIData] = useState<any>({
        loading: true,
        error: false,
        data: undefined
    });



    useMemo(async () => {
        const data = await getDailyNFTSellers();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
